import * as React from "react";

function SvgChevronBottom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.293 4.293l1.414 1.414L8 12.414 1.293 5.707l1.414-1.414L8 9.586l5.293-5.293z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgChevronBottom;
